/*
 * @Author:
 * @Description:
 * @Date: 2024-11-20 19:21:18
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/views/report/api/report.js
 */
import Http from '@/utils/http/index';
export default {
  /**
   * 月度对账单列表
   */
  queryList(params) {
    return Http.get('/monthReconOrder/queryMonthReconOrderList', { params });
  },

  /**
   * 下载
   * @returns
   */
  downloadReport(params) {
    return Http.get('/monthReconOrder/download', { params });
  },

  /**
   * 成功率表报
   * @returns
   */
  successRateReport(params) {
    return Http.get('/merchant/report/success', { params });
  },

  /**
   * 拒付率表报
   * @returns
   */
  refuseRateReport(params) {
    return Http.get('/merchant/report/repudiate', { params });
  },

  /**
   * 拒付率表报详情
   * @returns
   */
  refuseRateRepotDetails(params) {
    return Http.get('/merchant/report/repudiateDetail', { params });
  },

  /**
   * 表报币种列表
   * @returns
   */
  getReportCurrency(params) {
    return Http.get('/merchant/report/currency', { params });
  },

};
